import { useState } from 'react';
import { motion } from 'framer-motion';

const MemoryCard = ({ photo, onClick, index = 0 }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <motion.button
      type="button"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, delay: Math.min(index * 0.03, 0.25) }}
      whileTap={{ scale: 0.98 }}
      onClick={() => onClick?.(photo)}
      className="group relative aspect-square w-full overflow-hidden rounded-xl bg-transparent"
    >
      {!loaded && (
        <div className="absolute inset-0 animate-pulse rounded-xl bg-surface-100 dark:bg-surface-800/60" />
      )}
      <img
        src={photo.url}
        alt=""
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`h-full w-full object-cover transition-opacity duration-400 ${
          loaded ? 'opacity-100' : 'opacity-0'
        }`}
      />
    </motion.button>
  );
};

export default MemoryCard;
